import * as React from "react";

interface ButtonBigProps {
  label: string,
  onclick: (callback: any) => void,
  disabled: boolean,
  height: string,
  position: string
}

/**
 * Großer grüner Button
 */
export class ButtonBig extends React.Component<ButtonBigProps> {

  public static defaultProps = {
    label: "Label",
    disabled: false,
    height: 'normal',
    position: 'center'
  };

  render() {
    let classNames = 'avia-button react-button-big avia-icon_select-no avia-size-x-large avia-position-center avia-color-theme-color avia-position-' + this.props.position;

    if (this.props.height === 'small') {
      classNames += ' btn-small';
    }

    return <button onClick={this.props.onclick} disabled={this.props.disabled} type="button" className={classNames}>
      {this.props.label}
    </button>
  }
}